<svelte:options customElement={{
  tag: "faq-content",
  shadow: "none",
  props: {
    id: { type: "String" },
    sectionGray: { type: "String" },
    text: { type: "String" },
    faqarray: { type: "String"},
    url: { type: "String"}
  }
}} />

<script>
  import { onMount } from 'svelte';
  const Qicon = "/assets_default/icons/text_q.svg"
  const Aicon = "/assets_default/icons/text_a.svg"
  const Chevron = "/assets_default/icons/chevron_down.svg"
  import SectionHead from "@ce/SectionHead.svelte"

  let {
    id = "",
    sectionGray = "false",
    text = "",
    faqarray = "",
    url = ""
  } = $props();
  const moreButtonActive = $derived(url !== null && url !== undefined && url !== "");
  const sectionGrayActive = $derived(sectionGray === "true" || sectionGray === true);


  const data = $derived.by(() => {
  if (!faqarray) return [];

  if (typeof faqarray === 'string') {
    try {
      // JSON文字列を配列に変換
      console.log(faqarray)
      const parsed = JSON.parse(faqarray);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error("FAQデータのパースに失敗しました:", e);
      return [];
    }
  }

  // 最初から配列で渡された場合はそのまま返す
  return Array.isArray(faqarray) ? faqarray : [];
});
  //ジャンプリンクの遷移先アコーディオンを開く
  $effect(() => {
    if (data.length > 0) {
      // ページ読み込み時にハッシュがあれば開く
      const hash = window.location.hash.replace('#', '');
      const target = document.getElementById(hash);
      if (target && target.tagName === 'DETAILS') {
        target.open = true;
      }
    }
  });
  onMount(() => {
    // ページ内リンクをクリックした時に開く
    const handleHash = () => {
      const hash = window.location.hash.replace('#', '');
      const target = document.getElementById(hash);
      if (target && target.tagName === 'DETAILS') {
        target.open = true;
      }
    };
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  });
</script>

<section class={sectionGrayActive ? "owd-section:bg-light-gray spacing:bottom:64" : "owd-section spacing:bottom:64"} id="faq">
  <SectionHead caption="FAQ" title="よくある質問" text={text} />

  <div class={moreButtonActive ? "owd-accordion owd-accordion:qa" : "owd-accordion owd-accordion:qa spacing:bottom:40"}>
    {#each data as faq}
    <details class="owd-accordion-item" id="{faq.id}">
      <summary class="owd-accordion-item-head:qa">
        <img src="{Qicon}" alt="Q文字アイコン">
        <p class="owd-text:02 custom-display"><strong>{faq.head}</strong></p>
        <img class="owd-accordion-item-head-chevron" src="{Chevron}" alt="下矢印アイコン">
      </summary>
      <div class="owd-accordion-item-body:qa">
        <img src="{Aicon}" alt="A文字アイコン">
        <div class="owd-accordion-item-body-textarea">
          <p class="owd-text:02">{@html faq.text}</p>
          {#if faq.annotation}
            <ul class="owd-list:annotation">
              {#each faq.annotation as annotation}
              <li>{@html annotation}</li>
              {/each}
            </ul>
          {/if}
        </div>
      </div>
    </details>
    {/each}
  </div>
  {#if url}
  <div class="block:center" style="margin-top:32px">
    <a href="{url}" target="_blank" class="owd-button owd-button:large owd-button:secondary:white">よくある質問を見る</a>
  </div>
  {/if}
</section>


<style>
  .custom-display {
    display: flex;
  }
  .owd-section\:bg-light-gray{
    .owd-accordion-item{
      background-color: transparent !important;
    }
  }
  .owd-list\:annotation{
    margin-top: 12px;
  }
</style>
